import { render, staticRenderFns } from "./jobstatus.vue?vue&type=template&id=2f344fca&scoped=true&"
import script from "./jobstatus.vue?vue&type=script&lang=js&"
export * from "./jobstatus.vue?vue&type=script&lang=js&"
import style0 from "./jobstatus.vue?vue&type=style&index=0&id=2f344fca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f344fca",
  null
  
)

export default component.exports